export enum ModalVariantEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  Spaced = 'spaced', // spaced on mobile & desktop
  Full = 'full',
}
